<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormStock" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <label class="form-label" for="TipoMovimiento">Tipo de Movimiento</label>
							<select v-model="TipoMovimiento" @change="CambiarTipoMovimiento" class="form-control-search form-select" id="TipoMovimiento">
                                <option value="1">Entrada</option>
                                <option value="2">Salida</option>
							</select>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <label class="form-label" for="Nombre">Cantidad</label>
							<input type="text" v-model="objMaterial.Stock" class="form-control" id="Stock" placeholder="Ingresar Cantidad" @input="$onlyNums($event,objMaterial,'Stock');CalcularStock()"/>
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <span>En Stock: </span><span>{{ StockActual }}</span>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <span>Ahora: </span><span>{{ NuevoStock }}</span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <span>Minimo Stock: </span><span>{{ objMaterial.MinimoStock }}</span>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <span>Máximo Stock: </span><span>{{ objMaterial.MaximoStock }}</span>
                        </div>
                    </div>
                </form>
            </div>
        </template>
    </CLoader>
</template>

<script>
export default {
    name: 'FormStock',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objMaterial: {
				IdMaterial: 0,
                Nombre:'',
				Stock: 0,
				TipoMovimiento:'',
                Cantidad:0,
                MinimoStock:0,
                MaximoStock:0
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			StockActual:0,
            NuevoStock:0,
            TipoMovimiento:"1"
        }
    },
    methods: {
        async Guardar(){
            this.poBtnSave.DisableBtn = true;
            if ((Number(this.StockActual)+Number(this.objMaterial.Stock))>this.objMaterial.MaximoStock) {
                this.$toast.warning("El Nuevo Stock Es Mayor Al Máximo Registrado");
                this.poBtnSave.ShowSpinner=false;
                this.poBtnSave.DisableBtn=true;
                return false;
            }
            this.objMaterial.Cantidad=this.objMaterial.Stock;
            this.objMaterial.Stock=this.NuevoStock;
            this.objMaterial.TipoMovimiento=this.TipoMovimiento=="1" ? "Entrada"  : "Salida";
            await this.$http.put(
				'materialesStock/'+this.objMaterial.IdMaterial,this.objMaterial
			).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
        EjecutaConExito(res){
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_seccionMaterial');
        },
        EjecutaConError(err){
            this.objMaterial.Stock=this.objMaterial.Cantidad;
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar(){
            this.$http.get(
                "materiales/"+this.objMaterial.IdMaterial
            ).then((res) => {
                this.objMaterial = res.data.data;
                this.StockActual=res.data.data.StockReal;
                this.objMaterial.Stock=0;
                this.NuevoStock=this.StockActual;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.TipoMovimiento="1";
            this.objMaterial = {
				IdMaterial: 0,
				Nombre: '',
				Stock: 0,
				TipoMovimiento:'',
                Cantidad:0,
                MinimoStock:0,
                MaximoStock:0
            }
            this.errorvalidacion = [];
        },
        CambiarTipoMovimiento(){
            this.CalcularStock();
        },
        CalcularStock(){
            if (this.TipoMovimiento=="1") {
                this.NuevoStock=Number(this.StockActual)+Number(this.objMaterial.Stock);
                this.poBtnSave.ShowSpinner=true;
                this.poBtnSave.DisableBtn=false;
            }
            else{
                if (Number(this.StockActual)-Number(this.objMaterial.Stock)<0) {
                    this.$toast.warning("Stock Insuficiente");
                    this.poBtnSave.ShowSpinner=false;
                    this.poBtnSave.DisableBtn=true;
                }
                else{
                    this.NuevoStock=Number(this.StockActual)-Number(this.objMaterial.Stock);
                    this.poBtnSave.ShowSpinner=true;
                    this.poBtnSave.DisableBtn=false;
                }
            }
        }
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            this.objMaterial.IdMaterial=Id;
            this.Recuperar();
        });
    }
}
</script>